import { createContext, useContext, useState, type MutableRefObject } from 'react';
import { motion, type Transition, type Variants } from 'framer-motion';

export interface PageMotionProps {
  children: React.ReactNode;
  className?: string;
}

export const PAGE_ENTER_EASE = [0.22, 1, 0.36, 1] as const;
export const pageEnter = { opacity: 0, y: 6 };
export const pageShown = { opacity: 1, y: 0 };
export const pageEnterTransition: Transition = { duration: 0.26, ease: PAGE_ENTER_EASE };

export const noWaapi = () => {};

export const RouteEnteringContext = createContext<MutableRefObject<boolean> | null>(null);

/**
 * Обёртка появления страницы. Отыгрывает вход сама только там, где роутер не
 * анимирует: смена страницы внутри одного раздела (заявка → заявка, админка,
 * мессенджер) и страница, дождавшаяся своего чанка уже после входа.
 *
 * Для поочерёдного появления элементов списка внутри — `staggerItem`.
 *
 * @use корневой узел страницы, чтобы переход между разделами не читался как рывок. Элементы списка внутри — `staggerItem`.
 */
export const PageMotion: React.FC<PageMotionProps> = ({ children, className }) => {
  const entering = useContext(RouteEnteringContext);
  const [skip] = useState(() => entering?.current === true);
  return (
    <motion.div
      initial={skip ? false : pageEnter}
      animate={pageShown}
      transition={pageEnterTransition}
      onUpdate={noWaapi}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const staggerItem: Variants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
};
